import { useEffect, useState } from "react";
import { _AccountINFORPO, _PayrollEntityProperties, _RequestCredit, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { toast } from "react-toastify";
import { CardTaps } from "../../../../theme/Component/CardTaps";
import { PersonalAccountData } from "../../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/PersonalAccountData";
import { SimulatorAmountSelector } from "./Components/SimulatorAmountSelector";
import { SelectCodeudor } from "./Components/SelectCodeudor";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { MASK_MONEY } from "../../../../theme/Component/BasicTable";
import { Alert } from "../../../../theme/Component/Alert";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    formMoney: boolean,
    formCodeudor?: boolean,
}

export const CC010 = ({ configProcedure }: Props) => {

    const acc = useDataBean(_AccountINFORPO)
    const { instance, bean, setBean } = useDataBean(_RequestCredit);
    const payroll = useDataBean(_PayrollEntityProperties);

    const [props, setProps] = useState<any>({});
    const [codeudor, setCodeudor] = useState<any>({});
    const [isExemptGrade, setIsExemptGrade] = useState(false);


    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
        getReuqest();
        acc.instance.searchCreditAffiliateByNit(_single.getAffiliate().Nit).then(
            (resp) => {
                acc.setBean(resp)
            }
        ).catch(err => {
            console.log(err)
        })
    }, [configProcedure?._pocessData])

    const onExportMap = () => {

        updateCredit({ ...bean, JSONDeudor: JSON.stringify(acc.bean) })

        const summary = {
            "Deudor - Nombres y Apellidos": `${acc.bean.PrimerNombre} ${acc.bean.SegundoNombre} ${acc.bean.PrimerApellido} ${acc.bean.SegundoApellido}`,
            "Deudor - Grado": acc.bean.IDGradoPersonaName,
            "Deudor - Tipo de Identificación": acc.bean.IDTipoIdentificacionName,
            "Deudor - Numero de Identificación": acc.bean.Nit,
            "Deudor - Caja Nominadora": acc.bean.IDCajaNominadoraName,
            "Deudor - Tiempo de Servicio": acc.bean.TiempoServicio,
            "Deudor - Correo Institucional": acc.bean.CorreoInstitucional,
            "Credito - Valor Solicitado": _single.formatMoney(bean.AmountCredit),
            "Credito - Cuotas": bean.Cuotes,
            "Credito - Procentaje": `${bean.AmountTax}%`,
            ...(bean.IDAccountCodeuda && {
                "Codeudor - Nombres y Apellidos": `${codeudor.PrimerNombre} ${codeudor.SegundoNombre} ${codeudor.PrimerApellido} ${codeudor.SegundoApellido}`,
                "Codeudor - Grado": codeudor.IDGradoPersonaName,
                "Codeudor - Tipo de Identificación": codeudor.IDTipoIdentificacionName,
                "Codeudor - Numero de Identificación": codeudor.Nit,
                "Codeudor - Caja Nominadora": codeudor.IDCajaNominadoraName,
                "Codeudor - Tiempo de Servicio": codeudor.TiempoServicio,
                "Codeudor - Correo Personal": codeudor.CorreoPersonal,
                "Codeudor - Correo Institucional": codeudor.CorreoInstitucional,
            })
        };


        configProcedure?._pushInfo(
            _single.jsonToBootstrapTable(summary)
        )

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap({ Obs: "Se actualiza Documentacion por parte del usario y se envia para validación" })
        }

    }

    useEffect(() => {
        if (acc.bean?.IDCajaNominadora) {
            const props = { IDPayrollEntity: acc.bean?.IDCajaNominadora };
            payroll.instance.getPayrollEntityPropertiesCatalogPorPropiedades(props, null).then(
                (resp) => {
                    if (resp.length > 0) {
                        const x = resp[0].DataBeanProperties?.ListGradeExempt
                            ? JSON.parse(resp[0].DataBeanProperties?.ListGradeExempt)
                            : [];
                        payroll.setLista(x);

                        const found = x.some((item) => item.IDCreditProperties == acc.bean.IDGradoPersona);
                        setIsExemptGrade(found);
                    }
                }
            ).catch(
                err => { toast.error(err); }
            );
        }
    }, [acc.bean.IDCajaNominadora, acc.bean.IDGradoPersona]);


    useEffect(() => {
        if (bean.JSONCodeuda?.trim()) {
            setCodeudor(JSON.parse(bean.JSONCodeuda))
        }
    }, [bean.JSONCodeuda])

    const updateCredit = (value) => {
        instance.updateRequestCredit(value).then(
            (resp) => {
                getReuqest();
            }
        ).catch(err => { console.log(err) })
    }

    const getReuqest = () => {
        const props = {
            IDProcedureImp: configProcedure._procedure.IDProcedureImp
        }
        instance.getRequestCreditCatalogPorPropiedades(props, null).then(
            (resp) => {
                setBean(resp[0].DataBeanProperties)
            }
        ).catch(err => {
            toast.error(err)
        })
    }

    useEffect(() => {
        if (props.RequiresCodebtor && !isExemptGrade) {
            setTaps([
                { id: 0, name: 'Actualización datos Personales', disable: false },
                { id: 1, name: 'Monto a Solicitar', disable: false },
                { id: 2, name: 'Codeudor', disable: false },
                { id: 3, name: 'Documentos', disable: false },
                { id: 4, name: 'Resumen', disable: false },
            ]);
        } else {
            setTaps([
                { id: 0, name: 'Actualización datos Personales', disable: false },
                { id: 1, name: 'Monto a Solicitar', disable: false },
                { id: 3, name: 'Documentos', disable: false },
                { id: 4, name: 'Resumen', disable: false },
            ]);
        }
    }, [props, isExemptGrade]);


    const [taps, setTaps] = useState<any[]>([
        { id: 0, name: 'Actualización datos Personales', disable: false },
        { id: 1, name: 'Monto a Solicitar', disable: false },
        { id: 3, name: 'Documentos', disable: false },
        { id: 4, name: 'Resumen', disable: false },
    ])

    const [indexTap, setIndexTap] = useState(0);

    return (
        <CardTaps index={indexTap} updateIndex={setIndexTap} taps={taps} >
            <div className="row">
                {indexTap === 0 &&
                    <div className="col-md-12">
                        <PersonalAccountData idAffiliate={_single.getAccountID()} key={indexTap} showOnlyTabId={0} onClickSave={(e) => {
                            setIndexTap(1);
                            configProcedure._pushProps?.({ IDCajaNominadora: e.IDCajaNominadora, IDGradoPersona: e.IDGradoPersona });
                        }} />
                    </div>
                }
                {indexTap === 1 &&
                    <div className="col-md-12">
                        <SimulatorAmountSelector
                            creditMonths={bean.Cuotes}
                            creditValue={bean.AmountCredit}
                            loanLine={props.IDLoanLine}
                            onChange={(e) => {
                                setIndexTap(props.RequiresCodebtor && !isExemptGrade ? 2 : 3);
                                updateCredit({ ...bean, AmountCredit: e.CreditValue, AmountTax: e.CurrentPercentInterest, JSONCredit: JSON.stringify(e), Cuotes: e.CreditQuotes });
                            }} />
                    </div>
                }
                {indexTap === 2 &&
                    <>
                        {isExemptGrade &&
                            <div className="col-md-12 mb-4">
                                <Alert clase="info" children={`Su grado esta excento de seleccionar un codeudor, puede seleccionarlo o omitir esta información`} />
                            </div>
                        }
                        <div className="col-md-12">
                            <SelectCodeudor
                                Affiliate={bean.JSONCodeuda ? JSON.parse(bean.JSONCodeuda) : {}}
                                onChange={(e) => {
                                    setIndexTap(3);
                                    updateCredit({
                                        ...bean,
                                        IDAccountCodeuda: e.IDAccount,
                                        JSONCodeuda: JSON.stringify(e)
                                    });
                                    configProcedure._pushProps?.({ IDAccountCodeuda: e.IDAccount });
                                }}
                            />

                        </div>
                    </>
                }
                {indexTap === 3 &&
                    <div className="col-md-12"> 
                        <PersonalAccountData _LoanLine={props.IDLoanLine} idAffiliate={_single.getAccountID()} key={indexTap} showOnlyTabId={2} onClickSave={() => {
                            setIndexTap(4);
                        }} type={[100, 101]} />
                    </div>
                }

                {indexTap === 4 &&
                    <>
                        <div className="col-md-12">
                            {bean.AmountCredit &&
                                <>
                                    <div className="col-md-12">
                                        <h5>Credito</h5>
                                    </div>

                                    <div className="col-md-12 d-flex justify-content-between align-items-center">
                                        <strong>Linea de Credito</strong>
                                        <div dangerouslySetInnerHTML={{ __html: bean.JSONCredit ? JSON.parse(bean.JSONCredit).Name : "" }}></div>
                                    </div>
                                    <div className="col-md-12 d-flex justify-content-between align-items-center">
                                        <strong>Valor Solicitado:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(bean.AmountCredit, MASK_MONEY) }}></div>
                                    </div>
                                </>
                            }
                            {bean.Cuotes &&
                                <div className="col-md-12 d-flex justify-content-between align-items-center">
                                    <strong>Cuotas:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: bean.Cuotes }}></div>
                                </div>
                            }
                            {bean.AmountTax &&
                                <div className="col-md-12 d-flex justify-content-between align-items-center">
                                    <strong>Procentaje:</strong>
                                    <div dangerouslySetInnerHTML={{ __html: `${bean.AmountTax}%` }}></div>
                                </div>
                            }
                            <div className="col-md-12">
                                <hr />
                            </div>
                            {bean.IDAccount &&
                                <>
                                    <div className="col-md-12">
                                        <h5>Deudor</h5>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Nombres y Apellidos:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${acc.bean.PrimerNombre} ${acc.bean.SegundoNombre} ${acc.bean.PrimerApellido} ${acc.bean.SegundoApellido}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Grado:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${acc.bean.IDGradoPersonaName ?? "N/A"}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Tipo de Identificación:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${acc.bean.IDTipoIdentificacionName ?? "N/A"}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Numero de Identificación:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${acc.bean.Nit ?? "N/A"}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Caja Nominadora:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${acc.bean.IDCajaNominadoraName ?? "N/A"}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Tiempo de Servicio:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${acc.bean.TiempoServicio ?? "N/A"}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Correo Personal:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${acc.bean.CorreoPersonal ?? "N/A"}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Correo Institucional:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${acc.bean.CorreoInstitucional ?? "N/A"}` }} />
                                    </div>
                                </>
                            }

                            <div className="col-md-12">
                                <hr />
                            </div>
                            {bean.IDAccountCodeuda &&
                                <>
                                    <div className="col-md-12">
                                        <h5>Codeudor</h5>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Nombres y Apellidos:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${codeudor.PrimerNombre} ${codeudor.SegundoNombre} ${codeudor.PrimerApellido} ${codeudor.SegundoApellido}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Grado:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${codeudor.IDGradoPersonaName ?? "N/A"}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Tipo de Identificación:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${codeudor.IDTipoIdentificacionName ?? "N/A"}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Numero de Identificación:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${codeudor.Nit}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Caja Nominadora:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${codeudor.IDCajaNominadoraName ?? "N/A"}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Tiempo de Servicio:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${codeudor.TiempoServicio ?? "N/A"}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Correo Personal:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${codeudor.CorreoPersonal ?? "N/A"}` }}></div>
                                    </div>
                                    <div className="col-lg-6 my-2">
                                        <strong>Correo Institucional:</strong>
                                        <div dangerouslySetInnerHTML={{ __html: `${codeudor.CorreoInstitucional ?? "N/A"}` }}></div>
                                    </div>
                                </>
                            }

                        </div>
                        <div className="col-md-12 d-flex justify-content-center align-content-center mt-3">
                            <BasicButton
                                disable={
                                    props.RequiresCodebtor && !isExemptGrade
                                        ? !(bean.JSONCredit?.trim() && bean.JSONCodeuda?.trim())
                                        : !bean.JSONCredit?.trim()
                                }

                                eventClick={onExportMap}
                                icon="ri-send-plane-line"
                                children={`Enviar Solicitud`}
                            />
                        </div>
                    </>
                }


            </div>
        </CardTaps>
    );
};